/**
 * Application Configuration
 *
 * SETUP INSTRUCTIONS:
 * 1. Create a Supabase account at https://supabase.com
 * 2. Create a new project
 * 3. Go to Settings -> API and copy the URL and anon key
 * 4. Replace the placeholder values below
 *
 * For Stripe (Phase 3):
 * 1. Create a Stripe account at https://stripe.com
 * 2. Get your publishable key from the Dashboard -> Developers -> API keys
 * 3. Replace the STRIPE_PUBLISHABLE_KEY below
 *
 * TIER CONFIGURATION:
 * Tier features and pricing are managed in the database and fetched dynamically.
 * - Use tierConfigService.getTierConfig() for tier definitions and pricing
 * - Use entitlementService.getEntitlements() for the current user's tier and features
 * - See SETUP.md for database schema and tier configuration
 */

// Supabase Configuration
export const SUPABASE_URL = 'https://wqhkodjvsqffydowkgck.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_bQMyiIfLW_DmbynxGxm3jQ_Pf1Ip2XW';

// Stripe Configuration (for payment integration)
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_YOUR_STRIPE_KEY';

// PayPal Configuration (for payment integration)
export const PAYPAL_CLIENT_ID = 'YOUR_PAYPAL_CLIENT_ID';

// Analytics Configuration (same accounts as ShowLark landing)
export const GA4_MEASUREMENT_ID = 'G-4ZJGYKY2L4';
export const POSTHOG_API_KEY = 'phc_OIaFRoSRBh1xazg0yUwz9cYwi8dYPxKzDiQxAwPO6Ju';
export const POSTHOG_API_HOST = 'https://dkeiv83n19cfke.showlark.com/';

// Check if configuration is valid
export function isConfigured() {
  return SUPABASE_URL !== 'https://YOUR_PROJECT_ID.supabase.co' &&
         SUPABASE_ANON_KEY !== 'YOUR_SUPABASE_ANON_KEY';
}
